const styles = (theme) => ({
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingTop: 'var(--dpoday-banner-height, 0px)',
    transition: 'padding-top 0.3s ease',
  },
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    flex: 1,
  },
  standardBackground: {
    background: theme.palette.primary.main,
  },
  customBackground: {
    backgroundColor: theme.palette.layout.main,
  },
  navbar: {
    transition: 'padding-top 0.3s ease',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    marginTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingRight: 12,
      paddingBottom: 12,
    },
  },
  contentContainer: {
    [theme.breakpoints.up('lg')]: {
      borderRadius: 20,
    },
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    backgroundColor: theme.palette.background.default,
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
  contentContainerMarginReduce: {
    marginTop: '-4px !important',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-8px !important',
    },
  },
})

export default styles
